import { css } from 'styled-components';
import { map } from '../../breakpoint';
export const overflow = () => css`
  ${_ref => {
  let {
    overflow
  } = _ref;
  return map(overflow, val => val !== undefined && css`
          overflow: ${val};
        `);
}};
`;